module.exports = __webpack_public_path__ + "img/hazardCategory6.0bcbb032.png";